import axios, { AxiosRequestConfig } from 'axios';
import { message as $message } from 'antd';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_AUTH_URL_API,
});

axiosInstance.interceptors.response.use(
  (config) => {
    if (config?.data?.message) {
      // $message.success(config.data.message)
    }
    return config;
  },
  (error) => {
    let errorMessage = 'Ha ocurrido un error';
    if (error?.message?.includes('Network Error')) {
      errorMessage = 'Error de red, verifique su red';
      $message.error(errorMessage);
    } else {
      errorMessage = error?.message;
    }
    // eslint-disable-next-line no-unused-expressions
    // error.message && $message.error(errorMessage);
    return {
      status: error?.response?.status,
      message: error?.response?.data?.class ? error.response.data.class : errorMessage,
    };
  },
);

export const setTokenGlobal = (token: string, xToken: string) => {
  axiosInstance.defaults.headers.common = {
    'Authorization': 'Bearer ' + token,
    'x-token': xToken,
  };
}

export type Response<T = any> = {
  status: number;
  message: string;
  data: T;
};

type Method = 'get' | 'post';

export type MyResponse<T = any> = Promise<Response<T>>;

/**
 *
 * @param method - request methods
 * @param url - request url
 * @param data - request data or params
 */
export const request = <T = any>(
  method: Method,
  urlPath: string,
  data?: any,
  config?: AxiosRequestConfig,
): MyResponse<T> => {
  const prefix = '/api/v1';
  const urlApi = prefix + urlPath;
  if (method === 'post') {
    return axiosInstance.post(urlApi, data, config);
  }
  return axiosInstance.get(urlApi, {
    params: data,
    ...config,
  });
};
